/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentMetaTeachingLoad model module.
 * @module model/StudentMetaTeachingLoad
 * @version 1.0.0
 */
class StudentMetaTeachingLoad {
    /**
     * Constructs a new <code>StudentMetaTeachingLoad</code>.
     * @alias module:model/StudentMetaTeachingLoad
     */
    constructor() { 
        
        StudentMetaTeachingLoad.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaTeachingLoad</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaTeachingLoad} obj Optional instance to populate.
     * @return {module:model/StudentMetaTeachingLoad} The populated <code>StudentMetaTeachingLoad</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaTeachingLoad();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('status_name')) {
                obj['status_name'] = ApiClient.convertToType(data['status_name'], 'String');
            }
            if (data.hasOwnProperty('need_teaching_load')) {
                obj['need_teaching_load'] = ApiClient.convertToType(data['need_teaching_load'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} status
 */
StudentMetaTeachingLoad.prototype['status'] = undefined;

/**
 * @member {String} status_name
 */
StudentMetaTeachingLoad.prototype['status_name'] = undefined;

/**
 * @member {Boolean} need_teaching_load
 */
StudentMetaTeachingLoad.prototype['need_teaching_load'] = undefined;






export default StudentMetaTeachingLoad;

